import { useEffect, useState } from 'react';

// ICONS
import { X } from 'lucide-react';

// COMPONENTS
import ThemeToggle from './themeToggleComponent';

export default function CustomizationDrawer({ isOpen, onClose }) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(isOpen);
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && show) {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, onClose]);

    return (
        <>
            {show && (
                <div
                    onClick={onClose}
                    className="fixed inset-0 bg-noir/60 z-40 transition-opacity duration-300"
                />
            )}

            <div
                className={`fixed top-4 bottom-4 right-4 w-64 rounded-lg bg-blanc dark:bg-dark-secondary z-50 transition-transform duration-300 ${
                    show ? 'translate-x-0' : 'translate-x-[110%]'
                }`}
            >
                <div className="flex items-center justify-between px-4 py-3 border-b border-noir dark:border-blanc">
                    <h2 className="text-h5">Personnalisation</h2>
                    <button
                        onClick={onClose}
                        className="p-1 rounded-lg hover:bg-noir/10 dark:hover:bg-gris/40 cursor-pointer"
                    >
                        <X className="text-noir dark:text-blanc" size={24} />
                    </button>
                </div>

                <div className="p-4 space-y-6">
                    <div>
                        <h3 className="text-body-m mb-4">Thème</h3>
                        <ThemeToggle />
                    </div>
                </div>
            </div>
        </>
    );
}